module.exports = __webpack_public_path__ + "2571e824862d96575058c11125c29fef.svg";